module.exports = __webpack_public_path__ + "img/main_visual.a21cfe6d.jpg";